import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";

import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { withTranslation } from "react-i18next";

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";

import { useGetLazyConsumerNumbersQuery } from "apis/User";
import debounceFn from "utils/debounce";
import ApplicantDetails from "Components/ApplicantDetails";
import { CONSUMER } from "common/constant";

const NameTransferApplicantDetails = ({ formik, t }) => {
  const {
    values: { utilityId, utilities, applicationTypeId, consumerNumber },
    setFieldValue,
  } = formik;

  const { roles } = useSelector((state) => state.Login);

  const [isLoading, setIsLoading] = useState(false);

  const [getConsumerNumbers, { data: { data: consumersOptions } = {} }] =
    useGetLazyConsumerNumbersQuery();

  const inputChangeHandler = async (value = "") => {
    try {
      await getConsumerNumbers({
        applicationType: applicationTypeId,
        consumerNumber: value,
        utilityId: utilityId
          ? utilityId
          : utilities.length
          ? utilities[0].value
          : "",
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    inputChangeHandler(consumerNumber);
  }, [consumerNumber, utilities]);

  return (
    <>
      <Row>
        <Typography className="mb-3" lineHeight="1" variant="h6">
          {t("Customer Details")}:
        </Typography>

        {roles.includes(CONSUMER) && (
          <Col md={4} sm={6}>
            <SelectField
              label={t("Customer Number") + "*"}
              name="utilityConsumerId"
              formik={formik}
              options={consumersOptions || []}
              getOptionLabel={(option) => option.consumerNumber}
              loading={isLoading}
              onChange={(_, { value }) => {
                const consumerNumber = consumersOptions.find(
                  ({ id }) => id === value
                ).consumerNumber;
                setFieldValue("utilityConsumerId", value);
                setFieldValue("consumerNumber", consumerNumber);
              }}
              onInputChange={(e, value) => {
                if (e) {
                  setFieldValue("utilityConsumerId", "");
                }
                debounceFn(() => inputChangeHandler(value), 300);
                setIsLoading(true);
              }}
              getOptionValue={(option) => option.id}
            />
          </Col>
        )}
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Customer Name") + "*"}
            name="consumerName"
            formik={formik}
            disabled
          />
        </Col>
      </Row>
      <Typography className="mb-3" lineHeight="1" variant="h6">
        {t("Applicant Details")}:
      </Typography>
      <ApplicantDetails formik={formik} />
    </>
  );
};
NameTransferApplicantDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};
export default withTranslation()(NameTransferApplicantDetails);
